import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import { API_URL } from "../services/api";

export default function Menudropdown({ onLocationChange }) {
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState("");

    useEffect(() => {
        const fetchSites = () => {
            axios.get(`${API_URL}/api/sites`)
                .then(res => {
                    setLocations(res.data.locations);
                    if (!selectedLocation && res.data.locations.length > 0) {
                        setSelectedLocation(res.data.locations[0]);
                        onLocationChange?.(res.data.locations[0]);
                    }
                })
                .catch(err => console.error(err));

        };

        fetchSites(); // initial fetch
        const interval = setInterval(fetchSites, 3000); // refresh every 3s
        return () => clearInterval(interval);
    }, [onLocationChange, selectedLocation]);

    const handleChange = (value) => {
        console.log("Dropdown selected:", value);
        setSelectedLocation(value);
        onLocationChange?.(value); // inform parent
    };

    return (
        <div>
            <h2> Select site </h2>
            <select
                value={selectedLocation}
                onChange={e => handleChange(e.target.value)}
            >
                {locations.map(loc => (
                    <option key={loc} value={loc}>{loc}</option>
                ))}
            </select>
        </div>
    );
}
